import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const services = [
    { name: 'Trademark Registration', path: '/trademark-registration' },
    { name: 'Copyright Registration', path: '/copyright-registration' },
    { name: 'Company Formation', path: '/company-formation' },
    { name: 'Trademark Search', path: '/trademark-search' },
    { name: 'Amazon Brand Registry', path: '/amazon-brand-registry' },
  ];

  return (
    <footer className="bg-[#1E1E1E] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Brand Info */}
          <div className="mb-6 md:mb-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_brand-protect-4/artifacts/0vt6b7dr_logo-03.png" 
              alt="Fine Trademark Logo" 
              className="h-10 sm:h-12 w-auto mb-3 sm:mb-4"
            />
            <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
              Your trusted partner for trademark registration, copyright protection, and business formation services in the USA.
            </p>
          </div>

          {/* Services */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-[#E5B80B]">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-[#E5B80B]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-[#E5B80B] transition-colors text-sm sm:text-base block">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-[#E5B80B]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 sm:space-x-3">
                <MapPin size={18} className="text-[#E5B80B] mt-1 flex-shrink-0 sm:w-5 sm:h-5" />
                <span className="text-gray-400 text-sm sm:text-base break-words">
                  611 Wilshire Blvd #900,<br />Los Angeles, CA 90017
                </span>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <Phone size={18} className="text-[#E5B80B] flex-shrink-0 sm:w-5 sm:h-5 mt-1" />
                <span className="text-gray-400 text-sm sm:text-base break-words">+1 (415) 915-6981</span>
              </li>
              <li className="flex items-start space-x-2 sm:space-x-3">
                <Mail size={18} className="text-[#E5B80B] flex-shrink-0 sm:w-5 sm:h-5 mt-1" />
                <span className="text-gray-400 text-sm sm:text-base break-words">info@finetrademark.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center text-gray-400">
          <p className="text-xs sm:text-sm">&copy; {new Date().getFullYear()} Fine Trademark. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
